import {
    inject,
} from "@angular/core";
import {
    ActivatedRouteSnapshot, CanActivateFn, GuardResult, RouterStateSnapshot
} from "@angular/router";

import { AuthenticationService } from "../services/authentication.service";
import { IAPI_APP_ROUTER_SERVICE } from "../constants/iapi-app-tokens";
import { NavigationSource } from "../../application/enums/navigation-source";

/**
 * This guard is used to ensure that the auth service has a valid authentication token before loading a route
 *
 * If the auth service has an expired token it will display an error message and sent them to the login page
 *
 * If the user is not authenticated it sends them to the login page
 *
 * Once the user is logged it it will return them to their previous page
 *
 * This guard should be attached to the Root AppRoute and it will apply to all of its children
 */
export const authenticationCanActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult => {

    const authService = inject(AuthenticationService);
    const appRouter = inject(IAPI_APP_ROUTER_SERVICE);

    if (authService.authenticatedUser) {
        // User is authenticated activate the route
        return true;
    }

    const token = authService.authToken;

    if (token && !token.isExpired) {
        // Token is valid activate the route
        return true;
    }

    // This will ensure the user is brought back to this url after login
    appRouter.setPostLoginPath(state.url);

    if (token?.isExpired) {
        // Token is expired the auth service will clear it and show an error message
        authService.handleExpiredToken();
    }
    // Send the user to the login page
    return appRouter.getLoginRedirectCommand(NavigationSource.Guard);
};
